<script setup lang="ts">
import { DatePicker } from '@angelblanco/v-calendar';
import '@angelblanco/v-calendar/dist/style.css';
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();

const props = defineProps({
  modelValue: {
    type: Date,
    default: null,
  },
  modal: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:model-value', 'close']);

// Ref for the date picker value
const date = ref(props.modelValue || null);

// Watch for changes in the modelValue prop and update the date ref accordingly
watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal !== date.value) {
      date.value = newVal;
    }
  },
);

// Watch for changes in the date ref and update the modelValue prop
watch(date, (newVal) => {
  if (newVal !== props.modelValue || newVal === null) {
    emit('update:model-value', newVal);
  }
});

// Disable all old dates
const today = new Date();

const attrs = {
  transparent: true,
  borderless: true,
  color: 'blue',
  highlight: false,
  class: 'rounded-lg bg-white',
  'is-dark': { selector: 'html', darkClass: 'dark-mode' },
  'first-day-of-week': 2,
};
</script>
<template>
  <div
    :class="{
      'bg-white dark:bg-gray-800 shadow-lg': props.modal,
    }"
    class="rounded-lg w-full calendar-container"
  >
    <DatePicker
      :locale="locale"
      v-model="date"
      :min-date="today"
      :expanded="true"
      v-bind="{ ...attrs, ...$attrs }"
      @closed="emit('close')"
    />
  </div>
</template>

<style>
@media only screen and (max-width: 600px) {
  .vc-day-content {
    font-size: 1.4rem !important;
  }

  .vc_day {
    width: 100% !important;
  }

  .vc-highlight {
    padding: 1rem !important;
  }

  .vc-weekday {
    font-size: 1rem !important;
  }

  .vc-week {
    margin-top: 1rem;
  }

  .vc-weekdays {
    margin-top: 1rem;
  }
  .vc-weeks {
    height: fit-content !important;
  }
}
</style>
